module.exports = __webpack_public_path__ + "static/shoe-e559e95f50de260d408824a0e28762ed.jpg";